
import React, { useEffect, useState } from 'react'
import Modal from 'components/modal'
import '../../less/contact-prefernces-modal.less'
import Field from 'components/controls/field'
import { Spinner } from '@blueprintjs/core'
import { axiosInstance } from 'network/apis'

const ContactPrefernecesModal = props => {
    const [allowContactByEmail, setAllowContactByEmail] = useState()
    const [user,setUser] = useState()
    const [spinnerLoading, setSpinnerLoading] = useState(true)
    const cognitoUserId = props.userId

    async function fetchSelectedUserDetails(cognitoUserId) {
        try {
          const result = await axiosInstance.get(`qstoolAdmin/get-all-users`, {params: {cognitoUserId: cognitoUserId}}, { handlerEnabled: true })
          console.log("result",result.data[0])
          setUser(result.data[0])
          setAllowContactByEmail(result.data[0].allow_contact_by_email)
          setSpinnerLoading(false)
        } catch (e) {
          console.log("an error occured ", e)
          setSpinnerLoading(false)
          props.showSnackbarMessageError(props.t('There was an error processing your request, please try again'))
          props.hideSnackbarMessage()
        }
      }
    
      useEffect(() => {
        setSpinnerLoading(true)
        console.log("cognitoUserId : ", cognitoUserId)
        props.userId && fetchSelectedUserDetails(cognitoUserId)
      }, [props.userId])
      
    return (
        <Modal
            title={"EDIT USER PREFERENCES"}
            isOpen={props.isOpen}
            className="contact-preferences-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Save & Update"
            onCancel={props.onClose}
            onSubmit={() => props.updateAllowContactByEmail({ 
                userId: props.userId, 
                allowContactByEmail: allowContactByEmail ? "1" : "0", 
                name: user.firstName+ " " + user.lastName, 
                pmUserId: props.pmUser.userId,
                pmName: props.pmUser.userFirstName +" "+ props.pmUser.userLastName})}
            isSubmitting={props.isSubmitting}
            enableSubmit={user && (user.allow_contact_by_email !== allowContactByEmail)}
        >
            {(spinnerLoading ) ? <Spinner intent="primary" /> :
                <div className="contact-preferences-modal-body">
                    <div className="contact-preferences-modal-text">
                        <p className='user-name'> {user.firstName} {user.lastName} </p>
                        <div className='line'>          </div>
                        <p className='email'>Email: {user.email}</p>
                        <p className='user-type'> User Types: {user.userRole === 1 ? props.t('qs.moderator') : user.userRole === 2 ? props.t('qs.pm') : props.t('qs.admin')}</p>
                        <p className='contact-preferences'> Contact Preferences</p>
                        <div className='line'></div>
                        <Field
                            type="checkbox"
                            label="Allow Contact By Email"
                            checked={allowContactByEmail}
                            onClick={(e) => setAllowContactByEmail(e.target.checked)}
                        />
                        {!user.allow_contact_by_email && <div className='unsubscribe'>UNSUBSCRIBE DATE: {props.formatDate(user.modifiedDate, 'MMMM Do YYYY, h:mma')} by {user.byWho}</div>}

                    </div>
                </div>}
        </Modal >
    )
}

export default ContactPrefernecesModal
